var _rect, _text, _rect2, _text2, _rect3, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitSpan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 34,
    width: 24,
    height: 32,
    rx: 5,
    fill: "#FAC1B5",
    opacity: 0.4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 56,
    fontFamily: "sans-serif",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#C75E5A",
    opacity: 0.4,
    textAnchor: "middle"
  }, "3")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 34,
    width: 24,
    height: 32,
    rx: 5,
    fill: "#FAC1B5",
    opacity: 0.7
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 56,
    fontFamily: "sans-serif",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#C75E5A",
    opacity: 0.7,
    textAnchor: "middle"
  }, "7")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 34,
    width: 24,
    height: 32,
    rx: 5,
    fill: "#F9907B"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 56,
    fontFamily: "sans-serif",
    fontSize: 18,
    fontWeight: "bold",
    fill: "white",
    textAnchor: "middle"
  }, "2")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitSpan);
export default __webpack_public_path__ + "static/media/DigitSpan.8c33415fa12be879845239b9f9a9e4ab.svg";
export { ForwardRef as ReactComponent };